"use client"



// Extracted from components/booru-detail-modal.tsx (pure move: same JSX, same behaviour).
interface AlbumPageCounterProps {
  currentAlbumPage: number
  hideUI: boolean
  isAlbum: boolean
  totalAlbumPages: number
  viewingAdSlot: number | null
}

export function AlbumPageCounter({
  currentAlbumPage,
  hideUI,
  isAlbum,
  totalAlbumPages,
  viewingAdSlot,
}: AlbumPageCounterProps) {

  return (
    <>
      {!hideUI && isAlbum && (
                <div className="absolute top-16 left-1/2 -translate-x-1/2 bg-black/70 rounded-full px-3 py-1 z-20">
                  <span className="text-white text-sm font-medium">
                    {viewingAdSlot !== null ? "Ad" : `${currentAlbumPage + 1} / ${totalAlbumPages}`}
                  </span>
                </div>
              )}
    </>
  )
}
